export default {
    /**
     * Kosz
     */
    Z_TRASH: "z.trash",
    /**
     * Publiczna Sesja Otwarcia Ofert
     */
    X_OPEN_OFFERS_PUBLIC_SESSION: "x.openOffersPublicSession",
    /**
     * Informacje z otwarcia ofert
     */
    X_OPEN_OFFERS: "x.openOffers",
}